import orderInstance from '../instance'

const restoreOrder = (orderId, data) => {
  return orderInstance.put('/orders/' + (orderId) + '/restore', data)
}

export default restoreOrder
